<template>
	<div>
		<v-sheet rounded elevation="4" class="mb-4">
			<company-selector class="pa-2" :hint="getLabel('switchOrAddHint', 'Switch or Add Practice')"></company-selector>
		</v-sheet>

		<div class="mb-4 text-center">
			<v-row v-if="tenant.settings.pricing.show" class="mb-3" justify="center">
				<v-col cols="auto">
					<v-btn class="hidden-md-and-up secondary--text font-weight-bold" width="150px" depressed @click="openPricingDialog"> Pricing Options </v-btn>
				</v-col>
			</v-row>
			<v-row class="mb-3 px-2" justify="center" dense>
				<v-col cols="12" class="py-1">
					<v-btn block class="hidden-md-and-up primary--text font-weight-bold" depressed @click="showFeaturedLocums">
						{{ getLabel('professionalDirectory', 'Locum Directory') }}
					</v-btn>
				</v-col>
				<v-col cols="12" class="py-1">
					<v-btn block color="#5f6169" class="hidden-md-and-up white--text font-weight-bold" depressed @click="openRequestForm">Permanent Placements</v-btn>
				</v-col>
			</v-row>
			<v-row v-if="tenant.settings.wallet.show" justify="center">
				<v-col cols="auto">
					<v-btn color="secondary" class="hidden-md-and-up mb-3 font-weight-bold" width="220px" @click="openWallet">
						{{ getWallet.generalLabel }} R{{ getWallet.total }}
					</v-btn>
				</v-col>
			</v-row>
		</div>

		<component
			:is="call_for_actions.length == 0 ? 'practice-find-locum-card' : call_for_actions[0].component"
			:data="call_for_actions.legth > 0 ? call_for_actions[0].data : []"
			@dismiss="dismissNotification"
		/>
		<practice-featured-locums-dialog></practice-featured-locums-dialog>
		<practice-quickbook-featured-locum-dialog></practice-quickbook-featured-locum-dialog>
		<InviteLocumPopUp />
		<v-row no-gutters>
			<v-col class="pb-0" cols="12">
				<v-expansion-panels accordion :multiple="false" flat :elevation="1">
					<v-expansion-panel v-if="$vuetify.breakpoint.width < 1264">
						<v-expansion-panel-header color="#f6f6f6" class="font-weight-bold ma-0 pa-0"> Booking Calendar </v-expansion-panel-header>
						<v-expansion-panel-content color="#f6f6f6" class="panel-0-padding"><practice-dashboard-big-calendar /></v-expansion-panel-content>
					</v-expansion-panel>
					<practice-upcoming-bookings />
					<practice-booking-requests-sent />
					<practice-applications-received />
					<practice-created-offers />
					<practice-booking-history />
				</v-expansion-panels>
			</v-col>
		</v-row>
	</div>
</template>

<script>
// Practice dropdown components
import { mapGetters } from 'vuex';
import PracticeUpcomingBookings from '@/components/ui/dashboard/practice/dropdowns/PracticeUpcomingBookings';
import PracticeBookingRequestsSent from '@/components/ui/dashboard/practice/dropdowns/PracticeBookingRequestsSent';
import PracticeApplicationsReceived from '@/components/ui/dashboard/practice/dropdowns/PracticeApplicationsReceived';
import PracticeCreatedOffers from '@/components/ui/dashboard/practice/dropdowns/PracticeCreatedOffers';
import PracticeBookingHistory from '@/components/ui/dashboard/practice/dropdowns/PracticeBookingHistory';

import PracticeFindLocumCard from '@/components/ui/dashboard/practice/cards/PracticeFindLocumCard';
import PracticeSwitchCard from '@/components/ui/dashboard/practice/cards/PracticeSwitchCard';
import PracticeDashboardBigCalendar from '@/components/ui/dashboard/practice/PracticeDashboardBigCalendar';

import PracticeOfferSet from '@/components/ui/dashboard/practice/cards/PracticeOfferSet';
import PracticeOfferDeleted from '@/components/ui/dashboard/practice/cards/PracticeOfferDeleted';
import PracticeRequestCancelled from '@/components/ui/dashboard/practice/cards/PracticeRequestCancelled';

import { bus } from '@/main';
import store from '@/store';
import PracticeFeaturedLocumsDialog from './PracticeFeaturedLocumsDialog.vue';
import InviteLocumPopUp from './InviteLocumPopUp.vue';
import PracticeQuickbookFeaturedLocumDialog from './PracticeQuickBookFeaturedLocumDialog.vue';
import CompanySelector from '@/components/ui/dashboard/practice/CompanySelector.vue';
import { Tracking } from '@utils';

export default {
	name: 'PracticeDashboardLandingZone',
	components: {
		PracticeFindLocumCard,
		PracticeUpcomingBookings,
		PracticeBookingHistory,
		PracticeBookingRequestsSent,
		PracticeSwitchCard,
		PracticeDashboardBigCalendar,

		PracticeCreatedOffers,
		PracticeApplicationsReceived,

		PracticeOfferSet,
		PracticeOfferDeleted,
		PracticeRequestCancelled,
		PracticeFeaturedLocumsDialog,
		InviteLocumPopUp,
		PracticeQuickbookFeaturedLocumDialog,

		CompanySelector,
	},
	props: {
		data: {},
	},
	data: () => ({}),
	computed: {
		...mapGetters(['getWallet']),

		call_for_actions() {
			return store.getters.getNotifications;
		},
	},
	mounted() {
		Tracking.track('PracticeDashBoardDisplay', {});
		if (this.data !== null && this.data !== undefined) {
			bus.$emit('show-quickbook-popup', { locum: this.data, index: 0 });
			Tracking.track('Prac_ViewLocumDetails_BookAgain');
		}
		const featuredLocumsDismissed = sessionStorage.getItem('featuredLocumsDismissed');
		if (!featuredLocumsDismissed) this.showFeaturedLocums();

		bus.$on('call-for-action', calledforaction => {
			if (!('component' in calledforaction) || !('data' in calledforaction)) {
				console.error("called for action with bad payload. Expected [string] 'component'. [Object] 'data' . Got :", calledforaction);
			} else {
				this.call_for_actions.push(calledforaction);
			}
		});
	},
	methods: {
		dismissNotification() {
			store.commit('POP_NOTIFICATION');
		},

		showFeaturedLocums() {
			bus.$emit('show-featured-popup');
		},
		openWallet() {
			bus.$emit('show-wallet-dialog');
		},
		openPricingDialog() {
			bus.$emit('show-pricing-dialog');
			Tracking.track('Pricing_Click');
		},
		openRequestForm() {
			bus.$emit('show-request-form');
			Tracking.track('Request_Click');
		},
	},
};
</script>

<style scoped>
.company-switch-sheet {
	border: 1px solid grey !important;
}
</style>
